<template>
  <component
    :is="draggableComponent"
    v-bind="$attrs"
  >
    <slot />
  </component>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { VueDraggableNext } from 'vue-draggable-next';

// Force Vue 3 mode for draggable to avoid compat mode issues
if (VueDraggableNext.compatConfig) {
  VueDraggableNext.compatConfig = { MODE: 3 };
}

export default defineComponent({
  name: 'VDraggable',
  inheritAttrs: false,
  computed: {
    draggableComponent() {
      return VueDraggableNext;
    },
  },
});
</script>
